import { DonorType } from '@/api/apis/case';
import { BloodSection } from './components/BloodSection';
import { CaseMatchSection } from './components/CaseMatchSection';
import { DonorDemographicsSection } from './components/DonorDemographicsSection';
import { LungsAdditionalInfoSection } from './components/LungsAdditionalInfoSection';
import { ParametersSection } from './components/ParametersSection';

type LungsDonorProfileFormProps = {
  donorType?: DonorType | null;
};

export const LungsDonorProfileForm = ({ donorType }: LungsDonorProfileFormProps) => (
  <div className="flex flex-col gap-6">
    <CaseMatchSection />
    <DonorDemographicsSection />
    <ParametersSection donorType={donorType} />
    <BloodSection />
    <LungsAdditionalInfoSection />
  </div>
);
